// Copyright (c) 2021 Deere & Company

import './index.scss';

import Dropzone from 'react-dropzone';
import PropTypes from 'prop-types';
import React from 'react';

function handleFileDrop ( files ) {

    this.onFileDrop( files[0] );

}

const FileUploadPanel = props => (
    <div className="file-upload-panel">
        <div className="upload-label">
            {props.uploadLabel}
        </div>
        <div className="upload-area">
            <Dropzone
                className="dropzone-area"
                accept=".csv"
                multiple={false}
                onDropAccepted={handleFileDrop.bind( props )}
            >
                {() => (
                    <div className="dropzone">
                        {props.file && (
                            <div className="dropzone-filename">
                                <i className="fa fa-folder" /> {props.file.name}
                            </div>
                        )}
                        <div className="dropzone-message">{props.message}</div>
                    </div>
                )}
            </Dropzone>
        </div>
    </div>
);

FileUploadPanel.propTypes = {
    onFileDrop: PropTypes.func.isRequired,
    uploadLabel: PropTypes.string.isRequired,
    message: PropTypes.string,
    file: PropTypes.object
};

export default FileUploadPanel;
